import { loadScript } from 'helpers/loadScriptAsync'
import { store } from 'store'
import { setOneSignalId, removeOneSignalId } from 'store/entities/identity/actions'
import { onSetSubscriptionState, onNotificationsBlocked } from 'store/entities/localSettings/actions'

/**
 * OneSignal
 * @see https://onesignal.com/apps/d513f74f-5ceb-44b3-bc58-55e9119c8a43/settings/webpush/install
 * @return {Promise<any>}
 */
export function oneSignalInit(oneSignalAppId) {
  return new Promise((resolve, reject) => {
    try {
      if (oneSignalAppId) {
        loadScript('https://cdn.onesignal.com/sdks/OneSignalSDK.js')
          .catch(reject)
          .then(() => {
            const OneSignal = window.OneSignal || []
            OneSignal.push(function() {
              OneSignal.init({
                appId: oneSignalAppId,
                // Uncomment for local testing. And change domain to localhost:YOURS_PORT on oneSignal site
                // allowLocalhostAsSecureOrigin: process.env.NODE_ENV === 'development',
                autoRegister: false,
                httpPermissionRequest: {
                  enable: true,
                },
                welcomeNotification: {
                  title: 'ProHabits',
                  message: 'Thanks for subscribing!',
                  // "url": "" /* Leave commented for the notification to not open a window on Chrome and Firefox (on Safari, it opens to your webpage) */
                },
              }).then(function() {
                // If we're on an unsupported browser, do nothing
                if (!OneSignal.isPushNotificationsSupported()) {
                  store.dispatch(onNotificationsBlocked())
                  return
                }
                OneSignal.on('subscriptionChange', function(isSubscribed) {
                  store.dispatch(
                    onSetSubscriptionState({
                      isPushEnabled: isSubscribed === true,
                      isOptedOut: isSubscribed === false,
                    })
                  )
                  if (isSubscribed) {
                    OneSignal.getUserId(function(userId) {
                      store.dispatch(setOneSignalId(userId))
                    })
                  } else {
                    OneSignal.getUserId(function(userId) {
                      store.dispatch(removeOneSignalId(userId))
                    })
                  }
                })
                resolve(OneSignal)
              })
            })
          })
      } else {
        reject(new Error('[OneSignal]: initialization failed - config:oneSignalAppId is empty'))
      }
    } catch (error) {
      reject(error)
    }
  })
}
